import dynamic from 'next/dynamic';
import Immagini3Tastic from './gruenland/3-immagini/Immagini3Tastic';
import AnnouncementBarTastic from './gruenland/announcement-bar/AnnouncementBarTastic';
import ContactUsTastic from './gruenland/contact-us/ContactUsTastic';
import Editoriale2Tastic from './gruenland/editoriale-2/Editoriale2Tastic';
import FooterCardsTastic from './gruenland/footer-cards/FooterCardsTastic';
import FooterMenuTastic from './gruenland/footer-menu/FooterMenuTastic';
import HeaderTastic from './gruenland/header/HeaderTastic';
import HeroBannerTastic from './gruenland/hero-banner/HeroBannerTastic';
import MaintenanceBarTastic from './gruenland/maintenance-bar/MaintenanceBarTastic';
import NewInTastic from './gruenland/new-in/NewInTastic';
import ProductSliderTastic from './gruenland/product-slider/ProductSliderTastic';
import StoreLocatorTastic from './gruenland/store-locator/StoreLocatorTastic';
import { TasticRegistry } from './types';
import YggdrasilCheckoutPaymentCallbackTastic from './yggdrasil/checkout-payment-callback/YggdrasilCheckoutPaymentCallbackTastic';
import YggdrasilCtaTastic from './yggdrasil/cta/YggdrasilCtaTastic';
import YggdrasilHubspotFormTastic from './yggdrasil/hubspot-form/YggdrasilHubspotFormTastic';
import YggdrasilImageTastic from './yggdrasil/image/YggdrasilImageTastic';
import YggdrasilMarkdownTastic from './yggdrasil/markdown/YggdrasilMarkdownTastic';
import YggdrasilNotFoundTastic from './yggdrasil/not-found/YggdrasilNotFoundTastic';
import YggdrasilPageTitleTastic from './yggdrasil/page-title/YggdrasilPageTitleTastic';
import YggdrasilPdfTastic from './yggdrasil/pdf/YggdrasilPdfTastic';
import YggdrasilPDPTastic from './yggdrasil/product-details/YggdrasilPDPTastic';
import YggdrasilPLPTastic from './yggdrasil/product-list/YggdrasilPLPTastic';
import YggdrasilSpacerTastic from './yggdrasil/spacer/YggdrasilSpacerTastic';

const YggdrasilAccountDetailsTastic = dynamic(
  () => import('./yggdrasil/account-details/YggdrasilAccountDetailsTastic'),
);
const YggdrasilAccountRegisterTastic = dynamic(
  () => import('./yggdrasil/account-register/YggdrasilAccountRegisterTastic'),
);
const YggdrasilAccountLoginTastic = dynamic(() => import('./yggdrasil/account-login/YggdrasilAccountLoginTastic'));
const YggdrasilPublicOrderTastic = dynamic(() => import('./yggdrasil/public-order/YggdrasilPublicOrderTastic'));
const YggdrasilReturnsTastic = dynamic(() => import('./yggdrasil/returns/YggdrasilReturnsTastic'));
const YggdrasilCartTastic = dynamic(() => import('./yggdrasil/cart/YggdrasilCartTastic'));
const YggdrasilCheckoutTastic = dynamic(() => import('./yggdrasil/checkout/YggdrasilCheckoutTastic'));
const YggdrasilRelatedProductsTastic = dynamic(
  () => import('./yggdrasil/related-products/YggdrasilRelatedProductsTastic'),
);
const YggdrasilAccountResetPassword = dynamic(
  () => import('./yggdrasil/account-reset-password/YggdrasilAccountResetPasswordTastic'),
);
const YggdrasilAccontThankyou = dynamic(() => import('./yggdrasil/thank-you/YggdrasilThankyouTastic'));

export const tastics = {
  'gruenland/footer-menu': FooterMenuTastic,
  'gruenland/header': HeaderTastic,
  'gruenland/product-slider': ProductSliderTastic,
  'grunland/announcement-bar': AnnouncementBarTastic,
  'grunland/contact-us': ContactUsTastic,
  'grunland/footer-cards': FooterCardsTastic,
  'grunland/maintenance-bar': MaintenanceBarTastic,
  'grunland/store-locator': StoreLocatorTastic,

  'yggdrasil/3-immagini': Immagini3Tastic,
  'yggdrasil/account-details': YggdrasilAccountDetailsTastic,
  'yggdrasil/account-login': YggdrasilAccountLoginTastic,
  'yggdrasil/account-register': YggdrasilAccountRegisterTastic,
  'yggdrasil/account-reset-password': YggdrasilAccountResetPassword,
  'yggdrasil/cart': YggdrasilCartTastic,
  'yggdrasil/cta': YggdrasilCtaTastic,
  'yggdrasil/checkout': YggdrasilCheckoutTastic,
  'yggdrasil/checkout-payment-callback': YggdrasilCheckoutPaymentCallbackTastic,
  'yggdrasil/editoriale-2': Editoriale2Tastic,
  'yggdrasil/hero-banner': HeroBannerTastic,
  'yggdrasil/hubspot-form': YggdrasilHubspotFormTastic,
  'yggdrasil/image': YggdrasilImageTastic,
  'yggdrasil/markdown': YggdrasilMarkdownTastic,
  'yggdrasil/new-in': NewInTastic,
  'yggdrasil/not-found': YggdrasilNotFoundTastic,
  'yggdrasil/page-title': YggdrasilPageTitleTastic,
  'yggdrasil/pdf': YggdrasilPdfTastic,
  'yggdrasil/product-details': YggdrasilPDPTastic,
  'yggdrasil/product-list': YggdrasilPLPTastic,
  'yggdrasil/public-order': YggdrasilPublicOrderTastic,
  'yggdrasil/returns': YggdrasilReturnsTastic,
  'yggdrasil/related-products': YggdrasilRelatedProductsTastic,
  'yggdrasil/spacer': YggdrasilSpacerTastic,
  'yggdrasil/thank-you': YggdrasilAccontThankyou,
} as TasticRegistry;
